module.exports = __webpack_public_path__ + "static/media/plan-badge.982bee5b.svg";